











































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import FilterBox from "../filter-box.vue";
import { GetMenzhenList } from "@/request/datacenter";
@Component({
  components: {
    FilterBox,
  },
})
export default class Name extends mixins(listMixin) {
  private data: any = [];
  private filterChange(e: any) {
    this.filters = JSON.parse(JSON.stringify(e));
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private goRead(item: any) {
    this.$emit("read", item);
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      门诊号: this.filters.search,
      科室名称: this.filters["科室"],
      西医诊断: this.filters["西医诊断"],
      就诊医生: this.filters["就诊医生"],
      current_page: this.filters.current_page,
      page_num: this.filters.page_count,
      patient_id: this.patient.patient_id,
      start_time:this.filters.startTime,
      end_time:this.filters.endTime,
    };
    GetMenzhenList(this, params, loading).then((res: any) => {
      this.data = res.data;
      this.filters.total_count = res.total_count;
      if (this.data.length > 0) {
        this.ifShowEmpty = false;
      } else {
        this.ifShowEmpty = true;
      }
    });
  }
  mounted() {
    this.getList();
  }
}
